import { MapPin } from "lucide-react";
import { IMAGES, SERVICE_STATES } from "@/lib/site";

export default function ServiceArea() {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="relative py-24 md:py-32 bg-gradient-to-b from-[#0B1120] via-[#0d1428] to-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-orange-500" />
              <span className="font-tech text-orange-400 text-xs">SERVICE COVERAGE</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              <span className="chrome-text">Nationwide</span>
              <br />
              <span className="ember-text">Storm Coverage.</span>
            </h2>
            <p className="mt-6 font-body text-slate-400 max-w-md">
              Active campaigns running in 20+ states across the U.S. — with priority
              targeting in tornado alley, hail belts, and major coastal storm zones.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              {[
                { v: "20+", l: "States" },
                { v: "100%", l: "Continental U.S." },
                { v: "24/7", l: "Storm Tracking" },
              ].map((s) => (
                <div key={s.l} className="forge-card p-4">
                  <div className="font-display text-2xl gold-text">{s.v}</div>
                  <div className="font-tech text-[10px] text-slate-400 mt-1">{s.l}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-2 max-w-md">
              {SERVICE_STATES.map((s) => (
                <span
                  key={s}
                  className="font-tech text-[10px] px-2.5 py-1 bg-slate-900/60 border border-slate-700/70 text-slate-300 hover:border-orange-500/40 hover:text-orange-300 transition-colors"
                  data-testid={`state-chip-${s.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {s}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 relative">
            <div className="relative tracing-beam p-3">
              <div className="relative aspect-[16/10] overflow-hidden rounded-sm">
                <img
                  src={IMAGES.usaMap}
                  alt="USA Service Area Map"
                  className="w-full h-full object-cover"
                />
                {/* Pin markers */}
                {[
                  { top: "60%", left: "45%", label: "TX" },
                  { top: "70%", left: "65%", label: "FL" },
                  { top: "50%", left: "48%", label: "OK" },
                  { top: "45%", left: "38%", label: "CO" },
                  { top: "62%", left: "55%", label: "LA" },
                  { top: "40%", left: "70%", label: "OH" },
                ].map((p) => (
                  <div
                    key={p.label}
                    className="absolute"
                    style={{ top: p.top, left: p.left }}
                  >
                    <div className="relative">
                      <MapPin size={20} className="text-orange-500 drop-shadow-[0_0_8px_rgba(255,107,0,0.8)]" />
                      <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-orange-500 animate-ping" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
